var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-row', {
    staticClass: "mb-3",
    attrs: {
      "align-h": "end"
    }
  }, [_c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.top",
      value: 'Somente irá importar orçamento com status: Autorizado',
      expression: "\n          'Somente irá importar orçamento com status: Autorizado'\n        ",
      modifiers: {
        "top": true
      }
    }],
    ref: "import-orcamento-button",
    staticClass: "btn btn-primary font-weight-bold mr-2",
    staticStyle: {
      "height": "38px"
    },
    on: {
      "click": _vm.buscarOrcamentos
    }
  }, [_vm._v(" Importar Orçamento ")])]), _c('b-card', [_c('b-tabs', {
    attrs: {
      "pills": "",
      "horizontal": _vm.windowWidth < 768,
      "vertical": _vm.windowWidth > 768,
      "nav-wrapper-class": _vm.windowWidth > 768 ? 'w-25' : 'w-100',
      "fill": ""
    }
  }, [_c('Cliente'), _c('Produto'), _c('Transportador'), _c('Faturamento'), _c('Informacoes')], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm.canSaveOrcamento ? _c('div', [_c('div', {
    staticClass: "form mb-5"
  }, [_vm.store.currentTab !== 0 ? _c('button', {
    staticClass: "btn btn-secondary font-weight-bold mr-2",
    on: {
      "click": _vm.handlePrevious
    }
  }, [_vm._v(" Anterior ")]) : _vm._e(), _vm.store.isUpdate && _vm.store.currentTab !== 4 ? _c('button', {
    staticClass: "btn btn-primary font-weight-bold mr-4",
    on: {
      "click": _vm.handleNext
    }
  }, [_vm._v(" Proximo ")]) : _vm._e(), _c('button', {
    ref: "submit_novo_pedido",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "disabled": _vm.isSavingPedido
    },
    on: {
      "click": _vm.salvarPedido
    }
  }, [_vm._v(" " + _vm._s(_vm.isSavingPedido ? "Salvando..." : "Salvar") + " ")]), _c('button', {
    ref: "submit_previa_nfe",
    staticClass: "btn btn-clean font-weight-bold",
    on: {
      "click": function click($event) {
        return _vm.confirmCancel('pedidos');
      }
    }
  }, [_vm._v(" Cancelar ")])])]) : _c('div', [_c('button', {
    staticClass: "btn btn-secondary font-weight-bold mr-4",
    attrs: {
      "disabled": _vm.store.currentTab === 0
    },
    on: {
      "click": _vm.handlePrevious
    }
  }, [_vm._v(" Anterior ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": _vm.handleNext
    }
  }, [_vm._v(" Proximo ")]), _c('button', {
    ref: "submit_previa_nfe",
    staticClass: "btn btn-clean font-weight-bold",
    on: {
      "click": function click($event) {
        return _vm.confirmCancel('pedidos');
      }
    }
  }, [_vm._v(" Cancelar ")])])])])])], 1), _c('b-modal', {
    attrs: {
      "id": "importarOrcamentoPedido",
      "title": "Importar Orçamento",
      "centered": "",
      "size": "lg"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          ref: "importar_orcamento",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.importarOrcamento
          }
        }, [_vm._v(" Importar ")]), _c('b-button', {
          on: {
            "click": function click() {
              _vm.selectedOrcamento = null;
              cancel();
            }
          }
        }, [_vm._v(" Cancelar ")])];
      }
    }])
  }, [_c('b-form', {
    staticClass: "form"
  }, [_c('b-row', {
    attrs: {
      "align-h": "center"
    }
  }, [_c('b-col', [_c('b-form-group', {
    key: _vm.keyToReRender,
    attrs: {
      "label": "Orçamento"
    }
  }, [_c('VueSelect', {
    ref: "orcamento",
    attrs: {
      "filterable": false,
      "options": _vm.orcamentosToImport
    },
    on: {
      "search": _vm.onSearchOrcamento
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.numero) + " - " + _vm._s(option.cliente) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.numero) + " - " + _vm._s(option.cliente) + " ")])];
      }
    }]),
    model: {
      value: _vm.selectedOrcamento,
      callback: function callback($$v) {
        _vm.selectedOrcamento = $$v;
      },
      expression: "selectedOrcamento"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o orçamento")])], 2)], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };